import { useCallback } from 'react'
import { useSignupStoreActions } from '../store/useSignupStore'

export const useResetSponsorshipVoucherFlow = () => {
  const { updateSignupData } = useSignupStoreActions()

  const resetSponsorshipVoucher = useCallback(() => {
    updateSignupData({ publicSponsorshipVoucher: undefined })
  }, [updateSignupData])

  return { resetSponsorshipVoucher }
}
